module.exports = {"name":"lghtml5","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.2.0","built":"2018-06-18","repo":"https://bitbucket.org/npaw/lghtml5-adapter-js","libVersion":"^6.2.6","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 30
// module chunks = 0